import { ToastType } from '@models';
import { useStore } from '@store';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export function useCopyToClipboard() {
  const { t } = useTranslation();
  const { setToast } = useStore((state) => ({ setToast: state.setToast }));
  const [isCopying, setIsCopying] = useState(false);

  const copy = async (text: string, event?: React.MouseEvent) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (isCopying) return;
    setIsCopying(true);
    try {
      await navigator.clipboard.writeText(text);
      setToast({ message: t('toasts.linkCopied'), type: ToastType.SUCCESS });
    } catch {
      setToast({ message: t('toasts.somethingWentWrong'), type: ToastType.ERROR });
    } finally {
      setTimeout(() => setIsCopying(false), 2000);
    }
  };

  return { copy };
}
